import PropTypes from 'prop-types';
import React from "react";

const BulletNavigation = ({count, selected, onSelect}) => {
    selected = Math.max(Math.min(count - 1, selected), 0);

    let bullets = [];
    for (let i = 0; i < count; i++) {
        bullets.push(<span
            className={i == selected? "selected": ""}
            key={i}
            onClick={() => onSelect(i)}
        />);
    }
    return <div className="bullets">{bullets}</div>;
};

BulletNavigation.propTypes = {
    count: PropTypes.number,
    selected: PropTypes.number,
    onSelect: PropTypes.func
};

export default BulletNavigation;


// WEBPACK FOOTER //
// ./src/kpi/components/BulletNavigation.jsx